// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import 'core-js/es6/promise'
// import 'core-js/es6/string'
// import 'core-js/es7/array'

import Vue from "vue";
import BootstrapVue from "bootstrap-vue";

import App from "./App";
import { initRouter } from "./router";
import store from "./store";
import { ValidatorDictionary, i18n } from "./i18n";

import { configurePermissions } from "./permission"; // permission control
import "./filters"; // permission control

import Notifications from "vue-notification";
import VeeValidate, { Validator } from "vee-validate";
import VueLoading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { Routes } from "./i18n";
import { mergeDeep } from "./utils/commons";

Vue.use(BootstrapVue);
Vue.use(Notifications);
Vue.use(VueLoading);
Vue.use(VeeValidate, {
  fieldsBagName: "vFields",
});

Validator.localize(ValidatorDictionary);

import { init as initCustomValidators } from "../common/validators";

initCustomValidators(Validator);

const supportedLocales = ["pt", "en", "es", "de", "zh", "id"];

function detectLocale() {
  const stored = localStorage.getItem("preferred-locale");
  if (stored && supportedLocales.includes(stored)) {
    return stored;
  }
  const browserLangs = navigator.languages || [navigator.language];
  for (const lang of browserLangs) {
    const prefix = lang.split("-")[0].toLowerCase();
    if (supportedLocales.includes(prefix)) {
      return prefix;
    }
  }
  return "pt";
}

const detectedLocale = detectLocale();
i18n.locale = detectedLocale;
Validator.localize(detectedLocale);

/* eslint-disable no-new */

function isWhite(color) {
  if (!color) return false;
  const normalized = color.trim().toLowerCase();
  return (
    normalized === "#fff" ||
    normalized === "#ffffff" ||
    normalized === "white" ||
    normalized.replace(/\s/g, "") === "rgb(255,255,255)"
  );
}

function loadTheme() {
  const portal = store.getters.portal;
  let cssName = portal.slug;
  if (portal.whitelabel) {
    cssName = portal.whitelabel;
    document
      .querySelector(":root")
      .style.setProperty("--theme-color", portal.color);
    document.documentElement.classList.add("portal-themed");

    document.title = portal.whitelabel.title;
  }
  if (portal.customCSS) {
    const portalBucket = store.getters.portalBucket;
    const link = document.createElement("link");
    link.href = `https://${portalBucket}/portal/css/${cssName}.css`;
    link.rel = "stylesheet";
    document.head.appendChild(link);
    return;
  }
  if (portal.color && !isWhite(portal.color)) {
    document
      .querySelector(":root")
      .style.setProperty("--theme-color", portal.color);
    document.documentElement.classList.add("portal-themed");
  }
}

async function loadCustomCopy() {
  const portal = store.getters.portal;
  if (!portal.customCopy) return;
  const portalBucket = store.getters.portalBucket;
  const filename = portal.whitelabel ? portal.whitelabel : portal.slug;
  try {
    const response = await fetch(
      `https://${portalBucket}/portal/copy/${filename}.json`
    );
    const copies = await response.json();
    const routes = copies.routes;
    delete copies.routes;
    for (const locale of Object.keys(copies)) {
      i18n.mergeLocaleMessage(locale, copies[locale]);
    }
    if (routes) {
      mergeDeep(Routes, routes);
    }
  } catch (e) {
    console.error("Error loading custom copies", e);
  }
}

store.dispatch("initApp").then(async () => {
  loadTheme();
  await loadCustomCopy();
  const router = initRouter();
  await configurePermissions();
  new Vue({
    el: "#app",
    router,
    store,
    i18n,
    render: (h) => h(App),
  });
});
